import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { verifyToken, setCredentials } from "../redux/slices/userSlice"; // ADD: verifyToken import
import { toast } from "react-toastify";

const AuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const accessToken = searchParams.get("access_token");
        const refreshToken = searchParams.get("refresh_token");
        const error = searchParams.get("error");

        // Debug: Tokens received
        console.log("🔑 Received tokens in AuthCallback:");
        console.log("   Access Token:", accessToken ? accessToken.substring(0, 20) + '...' : 'missing');
        console.log("   Refresh Token:", refreshToken ? 'present' : 'missing');

        if (error) {
            console.error("❌ Auth error from URL:", error);
            toast.error(`Authentication failed: ${error}`);
            navigate("/auth?mode=login", { replace: true });
            return;
        }

        if (accessToken) {
            console.log("🚀 Dispatching verifyToken with accessToken param");
            dispatch(verifyToken(accessToken))
                .unwrap()
                .then((payload) => {
                    console.log("✅ verifyToken Success:", { user: payload.user, hasRefresh: !!payload.refresh_token });
                    const credentials = {
                        access_token: accessToken,
                        refresh_token: refreshToken || null,
                        user: payload.user,
                    };
                    dispatch(setCredentials(credentials));
                    toast.success("Successfully logged in with Google!");
                    const redirectPath = payload.user?.access_role === 'admin' ? '/admin' : '/dashboard';
                    navigate(redirectPath, { replace: true });
                })
                .catch((err) => {
                    console.error("❌ verifyToken Failed:", err);
                    toast.error("Failed to complete authentication");
                    navigate("/auth?mode=login", { replace: true });
                });
        } else {
            toast.error("No authentication tokens received");
            navigate("/auth?mode=login", { replace: true });
        }
    }, [searchParams, navigate, dispatch]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-indigo-50">
            <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-blue-600 border-t-transparent"></div>
                <p className="mt-4 text-gray-600 font-medium">
                    Completing authentication...
                </p>
            </div>
        </div>
    );
};

export default AuthCallback;
